import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/creators/{creatorId}/integrations']['GET'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const getCreatorIntegrationAccounts = async ({ creatorId, page, perPage }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/creators/{creatorId}/integrations', { creatorId });
  const response = await noodleApiClient.get(path, {
    params: { page, perPage },
  });
  return response.data;
};

export default getCreatorIntegrationAccounts;
